module.exports = {
  "require": (function(x5) {
    return {
      "semantic-ui-react": require("semantic-ui-react"),
      "react-router-redux": require("react-router-redux"),
      "com/fiftyforms/cardweb/cardui/auth/l10n/cs-CZ.json": require("com/fiftyforms/cardweb/cardui/auth/l10n/cs-CZ.json"),
      "react-intl/locale-data/cs": require("react-intl/locale-data/cs"),
      "react-beautiful-dnd": require("react-beautiful-dnd"),
      "downloadjs": require("downloadjs"),
      "react-dom": require("react-dom"),
      "react": require("react"),
      "react-router": require("react-router"),
      "com/fiftyforms/cardweb/cardui/components/card/placeholder.png": require("com/fiftyforms/cardweb/cardui/components/card/placeholder.png"),
      "debug": require("debug"),
      "history": require("history"),
      "react-dropzone": require("react-dropzone"),
      "draft-js": require("draft-js"),
      "redux": require("redux"),
      "react-intl/locale-data/en": require("react-intl/locale-data/en"),
      "semantic-ui-calendar-react": require("semantic-ui-calendar-react"),
      "redux-thunk": require("redux-thunk"),
      "react-intl": require("react-intl"),
      "com/fiftyforms/cardweb/components/ff-logo@3x.png": require("com/fiftyforms/cardweb/components/ff-logo@3x.png"),
      "moment-timezone": require("moment-timezone"),
      "com/fiftyforms/cardweb/cardui/app/l10n/cs-CZ.json": require("com/fiftyforms/cardweb/cardui/app/l10n/cs-CZ.json"),
      "react-redux": require("react-redux")
    }[x5]
  })
}